document.addEventListener("DOMContentLoaded", function () {
  // Select all span elements that say "Add to cart"
  const addToCartSpans = document.querySelectorAll(
    '.quick-add__submit span:first-child'
  );

  addToCartSpans.forEach(function (span) {
    if (span.textContent.trim().toLowerCase() === "add to cart") {
      span.textContent = "+"; // Change the label
    }
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".quick-add__submit");
  buttons.forEach(button => {
    if (button.textContent.includes("Choose options")) {
      button.textContent = "+";
    }
  });
});




//for PDP page variant and qunt. selector grid
  document.addEventListener("DOMContentLoaded", function () {
    const variantSelects = document.querySelector('#variant-selects-template--19203810951299__main');
    const quantityForm = document.querySelector('#Quantity-Form-template--19203810951299__main');

    // Check if elements exist and haven't already been wrapped
    if (variantSelects && quantityForm && !document.querySelector('#variant-quantity-wrapper')) {
      // Create a wrapper div
      const wrapper = document.createElement('div');
      wrapper.id = 'variant-quantity-wrapper';
      wrapper.style.display = 'grid';
      wrapper.style.gridTemplateColumns = '1fr 1fr';
      wrapper.style.gap = '16px'; // adjust spacing
      wrapper.style.alignItems = 'center'; // vertical alignment
      wrapper.style.margin = '12px 0'; // spacing around the block

      // Insert the wrapper before variantSelects
      variantSelects.parentNode.insertBefore(wrapper, variantSelects);
      
      // Move both elements inside the wrapper
      wrapper.appendChild(variantSelects);
      wrapper.appendChild(quantityForm);
    }
  });

  // testing 

